import React from 'react'
import './calendar.scss'
import './react-calendar-custom-style.scss';
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";

const localizer = momentLocalizer(moment);

const CalendarComp = ({
    defaultDate = new Date(),
    defaultView = 'month',
    events,
    style,
    components,
    views = ["day", "week", "month"],
    popup = false,
    handleViewChange = () => { },
    handleNavigate = () => { },
    handleSelectEvent = () => { },
    handleSelectSlot = () => { }
}) => {

    // handleViewChange : return changed view type
    // handleNavigate   : return changed navigate ISO date
    // handleSelectEvent: return event object

    // {
    //     title: "Meeting with Team",
    //     start: new Date(2024, 10, 20, 10, 0), // Nov 27, 2024, 10:00 AM
    //     end: new Date(2024, 10, 20, 11, 30),  // Nov 27, 2024, 11:30 AM,
    //     bg_color: "#ff5733",
    // }

    const eventPropGetter = (event) => {
        return {
            style: {
                backgroundColor: event.bg_color || "#007bff", // Default to blue if no color is specified
                color: "white"
            },
        };
    };

    return (
        <div className="calendar-sub-comp-div">
            <Calendar
                views={views}
                localizer={localizer}
                events={events}
                startAccessor="start"
                endAccessor="end"
                selectable
                style={style}
                popup={popup}
                components={components}
                defaultDate={defaultDate}
                defaultView={defaultView}
                eventPropGetter={eventPropGetter}
                onView={handleViewChange}
                onNavigate={handleNavigate}
                onSelectEvent={handleSelectEvent}
                onSelectSlot={handleSelectSlot}
            />
        </div>
    )
}

export default CalendarComp